export const availableNotificationTemplates = [{ label: 'ndr message', value: 'NDR_MSG' }];
